import React from 'react';
import PropTypes from 'prop-types';
import FormatUtils from 'utils/format';
import {Text} from '@spothero/ui';
import StarRating from '../star-rating/';

const StarRatingWithCategory = ({numberOfReviews, starRating}) => {
    if (numberOfReviews < 10) {
        return <div className="StarRatingWithCategory" />;
    }

    const reviewsWithCommas = `(${FormatUtils.numWithCommas(numberOfReviews)})`;

    return (
        <div
            className="StarRatingWithCategory"
            data-testid="StarRatingWithCategory"
        >
            <StarRating stars={starRating} />
            <Text
                as="span"
                color="black"
                paddingRight={1}
                fontWeight="semibold"
                fontSize="sm"
                data-testid="StarRatingWithCategory-StarRating"
            >
                {starRating.toFixed(1)}
            </Text>
            <Text
                as="span"
                color="gray.dark"
                fontSize="sm"
                data-testid="StarRatingWithCategory-Reviews"
            >
                {reviewsWithCommas}
            </Text>
        </div>
    );
};

StarRatingWithCategory.propTypes = {
    numberOfReviews: PropTypes.number,
    starRating: PropTypes.number,
};

StarRatingWithCategory.defaultProps = {
    numberOfReviews: 0,
    starRating: 0,
};

export default StarRatingWithCategory;
